import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import profile from 'src/store/profile';
// @mui
import { Box, Drawer } from '@mui/material';
import { alpha } from '@mui/material/styles';
import WormWatcher from 'src/sections/@dashboard/app/WormWatcher';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
//
import navConfigST from './config_st';
import navConfigSTSS from './config_st_ss';
import navConfigSTFULL from './config_st_full';
import navConfig from './config_tch';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // Close the mobile nav when the route changes. Run only on pathname changes
    // to avoid immediately closing the drawer right after it opens.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        <Logo />
      </Box>

      <NavSection
        data={(() => {
          // teacher
          if (profile.isTeacher) {
            return profile.data && profile.data.groups > 0 ? navConfig : [navConfig[0]];
          }

          // student
          if (profile.access === 2) {
            // full access
            // if this full account also has selfstudy enabled on the server,
            // merge the selfstudy item into the full menu (avoid duplicates)
            const full = Array.isArray(navConfigSTFULL) ? [...navConfigSTFULL] : navConfigSTFULL;
            if (profile.data && profile.data.selfstudy === 1) {
              const hasSelfstudy = full.some((i) => i.path === '/student/selfstudy');
              if (!hasSelfstudy) {
                const ssItems = navConfigSTSS.filter((i) => i.path === '/student/selfstudy');
                // insert Self study after 'Уроки' (lessons) which is '/student/homeworks'
                const lessonsIndex = full.findIndex((i) => i.path === '/student/homeworks');
                if (lessonsIndex !== -1) {
                  full.splice(lessonsIndex + 1, 0, ...ssItems);
                } else {
                  full.push(...ssItems);
                }
              }
            }
            return full;
          }

          if (profile.access === 1) {
            return navConfigSTSS;
          }

          return navConfigST;
        })()}
      />

      <Box sx={{ flexGrow: 1 }} />

      <WormWatcher
        size={220}
        bottom={24}
        left={24}
        hoverRadiusPx={140}
        jumpPower={10}
        jumpDurationMs={1000}
        loadingSpeed={2}
        // loading={true}
      />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: (theme) => ({
              width: NAV_WIDTH,
              bgcolor: alpha(theme.palette.background.default, 0.85),
              borderRightStyle: 'dashed',
            }),
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: (theme) => ({
              width: NAV_WIDTH,
              bgcolor: alpha(theme.palette.background.default, 0.85),
            }),
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
